import AnimationDelay from '../utils/AnimationDelay';
import swap from '../utils/swap';

const cocktailShaker = async (a, delayController) => {
  return new Promise(async (resolve) => {
    const l = a.length;
    let notSorted = true;
    let iteration = 0;
    while(notSorted) {
      notSorted = false;
      for (let i = 0 + iteration; i < (l - 2 - iteration);  i += 1) {
        let j = i + 1;
        let left = a[i];
        let right = a[j];
        if (right < left) {
          swap(a, i, j);
          notSorted = true;
        }
        await delayController.delay();
      }
      if (!notSorted) {
        break;
      }
      for (let i = l - 2 - iteration; i >= (0 + iteration); i -= 1) {
        let j = i + 1;
        let left = a[i];
        let right = a[j];
        if (right < left) {
          swap(a, i, j);
          notSorted = true;
        }
        await delayController.delay();
      }
      iteration += 1;
    }
    resolve();
  })
};
export default class CocktailShakerAlgorithm {
  constructor({delayController} = {}) {
    this.delayController = delayController || new AnimationDelay();
  }
  sort = async (a) => {
    await cocktailShaker(a, this.delayController)
  }
}



// WEBPACK FOOTER //
// ./src/algorithms/cocktailshakersort.js